export default "/images/vendor/flag-icon-css/flags/4x3/gb-eng.svg?1fa89df2764a3f107c345ec3d56886e8";